module.exports = __webpack_public_path__ + "img/logo-2.d87d84b1.png";